//#region src/internal/metas.ts
const instances = /* @__PURE__ */ new WeakMap();
/** Share private coordination state between SDK packages without extending faro.metas. */
function getInternalMetas(metas) {
	let internal = instances.get(metas);
	if (!internal) {
		let sessionUpdateListeners = [];
		let captureFilters = [];
		internal = {
			addSessionUpdateListener: (listener) => {
				sessionUpdateListeners.push(listener);
			},
			removeSessionUpdateListener: (listener) => {
				sessionUpdateListeners = sessionUpdateListeners.filter((current) => current !== listener);
			},
			notifySessionUpdate: (update) => {
				sessionUpdateListeners.forEach((listener) => listener(update));
			},
			shouldCapture: () => captureFilters.every((filter) => filter()),
			addCaptureFilter: (filter) => {
				captureFilters.push(filter);
			},
			removeCaptureFilter: (filter) => {
				captureFilters = captureFilters.filter((current) => current !== filter);
			}
		};
		instances.set(metas, internal);
	}
	return internal;
}
//#endregion
export { getInternalMetas };

//# sourceMappingURL=metas.js.map